/** The way out of a lesson, from inside the lesson.
 *
 * The owner's complaint (2026-09-11): a student had to close and reopen the app to join a
 * different session. A signed-up student has the bottom navigation (BottomNav.tsx); a guest —
 * the common case — has nothing, and the join screen is not the place to fix it, because that
 * screen has exactly one job. So the door lives where the student is stuck: one quiet link in
 * the lesson header, in the leading position where a back control belongs.
 *
 * It does not leave the sitting: the join token stays in sessionStorage, so the join screen
 * offers this lesson straight back. Nothing is lost by tapping it, which is why it asks
 * nothing first.
 */
import { Link } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

export function LeaveLesson() {
  const { t } = useTranslation();
  return (
    <Link
      to="/j"
      className="-ml-2 inline-flex min-h-[var(--control-h)] shrink-0 items-center gap-1.5 rounded-[var(--radius-control)] px-2 text-sm text-[color:var(--ink-2)] hover:text-[color:var(--ink)]"
    >
      <span aria-hidden className="text-base leading-none">←</span>
      {t("student.otherLesson")}
    </Link>
  );
}
